export default "/images/eaa893c6f3ad2571816d604cffbcc919.png";